export default "__VITE_ASSET__CGiBiLEw__"